<template>
    <BasePanel :alvqa="alvqa" headline="lang_PUBLISHING_WORKS_CAPTION_OTHER_PERSONS">
        <template v-slot:panelContent>
            <v-data-table         
                :headers="headers"
                :items="item"
                hide-default-footer
                :no-data-text="$t('lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')"
                class="noMinWidth"
                :items-per-page="itemsPerPage"
            >
                <!-- alvqas for headers -->
                <template v-for="(header, i) in headers" v-slot:[`header.${header.value}`]>
                    <span :alvqa="header.alvqa" :key="i">{{ header.text }}</span>
                </template>

                <template v-slot:[`item.name`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.type + '-text-name'">
                        {{ item.name }}
                    </div>
                </template>
                <template v-slot:[`item.type`]="{ item }">
                    <div :alvqa="alvqa +'-list-row-' + item.type + '-text-type'">
                        {{ $t(getType(item.type)) }}
                    </div>
                </template>
            </v-data-table>
        </template>
    </BasePanel>
</template>

<script>
import BasePanel from '@/components/_base/BasePanel'
import { DropdownPublishingWorksOtherPersonsTypes } from '@/assets/dropdowns/alvDropdowns.js'

export default {
    name: "WorkOtherPersonsPanel",
    components: {
        BasePanel
    },
    props:{
        workAlvId: {
            type: String
        }
    },
    data() {
        return {
            alvqa: 'publishing-works-list-row-' + this.workAlvId + '-read-only-panel-other-persons'
        }
    },
    computed: {
        item() {
            let item = this.$store.getters.getExpandedWorks.find(element => {              
                return element.alvId === this.workAlvId
            }) 
            
            let otherInterestedParties = item.otherInterestedParties === null ? [] : item.otherInterestedParties
            return otherInterestedParties
        },
        headers() {
            return [
                {
                    text: this.$t("lang_CAPTION_NAME"), 
                    align: "left", 
                    value: "name",
                    sortable: false,
                    alvqa: this.alvqa + '-header-name'
                },
                {
                    text: this.$t("lang_PUBLISHING_WORKS_CAPTION_TYPE"), 
                    align: "left", 
                    value: "type",
                    sortable: false,
                    alvqa: this.alvqa + '-header-type'
                }
            ]
        },
        
        itemsPerPage() { return this.$store.getters.getItemsPerPage },
    },
    methods: {
        getType(value) {
            return DropdownPublishingWorksOtherPersonsTypes.find(type => {
                return type.value === value
            }).text
        }
    }
    
}
</script>

<style>
    .noMinWidth table {
        min-width: 0px !important;
    }
</style>